export const ID_BLACKLIST = [
  'new',
  'batch_upload',
  'create_batch_upload',
  'import_from_sap',
  'confirm_by_worksheet',
  'acao_multiplos_titulos',
];
